import { useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from '../forms/useForm';
import { usePagination } from '../pagination/usePagination';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';

export const useMicSiteArea = () => {

    const history = useHistory();

    const [sitesAreas, setSitesAreas] = useState([]);
    const [siteAreaId, setSiteAreaId] = useState(0);
    const [siteAreaSearch, setSiteAreaSearch] = useState([]);

    const [sites,setSites]=useState([]);

    const [method, setMethod] = useState("");
    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");

    const [loading, setLoading] = useState(false);
    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [searchAreaMic, setSearchAreaMic] = useState("");
    const [loadingExport, setLoadingExport] = useState(false);

    const [createSweet] = useSweetAlert();

    const [formValues, handleInputChange, reset, handleUpdateValues,] = useForm({
        id_mic_site: "",
        name: "",
    });

    const { id_mic_site, name, } = formValues;

    const numberItems = 10;
    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(sitesAreas.length, numberItems);

    useEffect(() => {
        getSites().then(result => {
            getSiteArea(result);
        });
    }, [history.location]);



    useEffect(() => {
        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;
        let listsSitesAreas = [];
        sitesAreas.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listsSitesAreas.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setSitesAreas(listsSitesAreas);
    }, [totalPageCount, currentPage])

    const [validaciones, setValidaciones] = useState({
        id_mic_site_valid: false,
        name_valid: false,
    });

   


    const getSiteArea = async (result = null) => {
        //////console.log(result, "dfdsf");
        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, "SitesAreas/List");
        //////console.log(respuesta);
        let sitios = result === null ? sites : result;


        if (respuesta.code === 200) {
            let listsSitesAreas = [];
            let startItems = 0;
            let endItems = numberItems;
            let aux = numberItems * currentPage;

            endItems = aux;

            startItems = endItems - numberItems;

            if (respuesta.data.length >= 1) {
    
                respuesta.data.forEach((data, index) => {
                    

                    let posicion = index + 1;
                    let visibleTable = false;

                    if (posicion > startItems && posicion <= endItems) {
                        visibleTable = true;
                    }
                    let sitio = sitios.find(x => x.id_mic_site == data.id_mic_site);

                    listsSitesAreas.push({
                        ...data,
                        nombre_sitio: sitio.name,
                        visibleTable: visibleTable,
                    });
                });
                ////console.log(listsSitesAreas);
                setSitesAreas(listsSitesAreas);
                setAreaMicData(listsSitesAreas)
                setSiteAreaSearch(listsSitesAreas);
            }
            else {
                // createSweet("error", "error", "Hubo un error!", "No se encontraron datos");
                setSitesAreas([]);
                setAreaMicData([]);
            }
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, getSiteArea);

        }
        else if(respuesta.code === 500){
            createSweet("error", "error", "Áreas", "Ocurrio un problema en el servidor");

        }
        else{
            createSweet("error", "warning", "Áreas", respuesta.data.msg);

        }
        // else {
        //     validarSesion(history, respuesta.code, getRooms);
        // }
    }

    

    const getSites= async()=>{
        let requestOptions={
            method: 'GET'
        };
        const respuesta=await sendRequest(requestOptions,'Sites/List');
        if (respuesta.code === 200) {
            setSites(respuesta.data);
            return respuesta.data;
        } 
    }


    const toggle = () => {
        setModal(!modal);
    }

    
    const openDialog = (title, mode) => {
        setModalTitle(title);
        setMethod(mode);
        setModal(true);
    };

    const closeDialog = () => {
        setModal(false);
    };


    const openDeleteAlert = () => {
        setShowDeleteAlert(true); 
        setModalAlert(true);  
    };

    const closeDeleteAlert = () => {
        setModalAlert(false);   
    };
        

    const handleCreate = () => {
        handleUpdateValues({
            id_mic_site: "",
            name: "",
        });

        setValidaciones({
            id_mic_site_valid: false,
            name_valid: false,
        });

        //setRoomId(0);
        setMethod("create");
        setModalTitle("Crear área");
        openDialog("Crear área", "create");
        getSites();
    }

    const saveCreate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }        

        let mValues = JSON.stringify(formValues);


        let requestOptions = {
            method: 'POST',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "SitesAreas/Create");

        if (respuesta !==null) {
            //getRooms();
            //reset();
            createSweet("create", "success", "Éxito!", "Sitio creado con éxito");
            setLoading(false);
            closeDialog();
            handleUpdateValues({
                id_mic_site:"",
                name:"",
            })
            getSiteArea();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveCreate);
            setLoading(false);
        }
        else if(respuesta.code === 500){
            createSweet("error", "error", "Áreas", "Ocurrio un problema en el servidor");
        }
        else{
            createSweet("error", "warning", "Áreas", respuesta.data.msg);
        }
        // else {
        //     setLoading(false);
        //     validarSesion(history, respuesta.code, saveCreate);
        // }
    }

    const handleUpdate = (id_mic_site_area) => {
        let add = sitesAreas.find(s => s.id_mic_site_area === parseInt(id_mic_site_area));

        handleUpdateValues({
            id_mic_site: add.id_mic_site,
            name: add.name,
        });

        setValidaciones({
            id_mic_site_valid: false,
            name_valid: false,
        });

        setSiteAreaId(id_mic_site_area);
        setMethod("update");
        setModalTitle("Actualización de área");
        openDialog("Editar área", "update");
    }

    const saveUpdate = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        let body = {
            id_mic_site_area: siteAreaId,
            id_mic_site:sites,
            ...{ ...formValues }
        };

        let mValues = JSON.stringify(body);

        let requestOptions = {
            method: 'PUT',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "SitesAreas/Update");

        if (respuesta.code === 200) {
            getSiteArea();
            createSweet("create", "success", "Éxito!", "Área actualizada");
            setLoading(false);
            closeDialog();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveUpdate);
            setLoading(false);
        }
        else if(respuesta.code === 500){
            createSweet("error", "error", "Áreas", "Ocurrio un problema en el servidor");
            setLoading(false);
        }
        else{
            createSweet("error", "warning", "Áreas", respuesta.data.msg);
            setLoading(false)
        }
        // else {
        //     setLoading(false);
        //     validarSesion(history, respuesta.code, saveUpdate);
        // }
    }

    const handleDelete = (id_mic_site_area) => {
        let siteArea = sitesAreas.find(s => s.id_mic_site_area === parseInt(id_mic_site_area));

        if (siteArea) {
            handleUpdateValues({
                id_mic_site: siteArea.id_mic_site,
                name: siteArea.name,
            });
        }

        setSiteAreaId(id_mic_site_area);
        setMethod("delete");
        setModalTitle("Eliminar área");
        setShowDeleteAlert(true);
        setModalAlert(true);
    }


    const saveDelete = async (e) => {
        e.preventDefault();
        setLoading(true);

        let requestOptions = {
            method: 'DELETE'
        };

        const respuesta = await sendRequest(requestOptions, `SitesAreas/${siteAreaId}`);
        if (respuesta!==null) {
            getSiteArea();
            setSiteAreaId(0);
            setLoading(false);
            createSweet("delete", "info", "Exito!", "Área eliminada");
            setShowDeleteAlert(false);
            setModalAlert(false);
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveDelete);
            setLoading(false);
        }
        else if(respuesta.code === 500){
            createSweet("error", "error", "Áreas", "Ocurrio un problema en el servidor");
            setLoading(false);
        }
        else{
            createSweet("error", "warning", "Áreas", respuesta.data.msg);
            setLoading(false)
        }
    }


    const validarForm = () => {
        let statusValidation = false;
        let newValidations = {};

        if (formValues.name === "" || formValues.name.length < 2) {
            newValidations = {
                ...newValidations,
                name_valid: true
            };
            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                name_valid: false
            }
        }
        if (formValues.id_mic_site === "" || formValues.id_mic_site <= 0) {
            newValidations = {
                ...newValidations,
                id_mic_site_valid: true
            };
            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                id_mic_site_valid: false
            }
        }

        setValidaciones(newValidations);

        return statusValidation;
    }

    const handleSearchSiteArea = (e) => {

        let busqueda = e.target.value;
        let newMethod = [];

        siteAreaSearch.forEach(element => {            

            let cadena = element.name.toUpperCase();
            if (cadena.indexOf(busqueda.toUpperCase()) > -1) {
                element.visibleTable = true;
                newMethod.push(element);
            }
        });
        setSitesAreas(newMethod);
    }

    const [areaMicData, setAreaMicData] = useState([]);

    const handleSearch = (e) => {
        setSearchAreaMic(e);

        let busqueda = e.toUpperCase();
        let newAreaMic = [];

        if (busqueda === "") {
            setSitesAreas([...areaMicData]);
        } else {
            areaMicData.forEach(element => {

                let cadenaName = element.name?.toUpperCase() || "";
                let cadenaSitio = element.nombre_sitio?.toUpperCase() || "";

                if (
                    cadenaName.indexOf(busqueda) > -1 ||
                    cadenaSitio.indexOf(busqueda) > -1
                ) {
                    element.visibleTable = true;
                    newAreaMic.push(element);
                }
            });

            setSitesAreas([...newAreaMic]);
        }
    };


    const handleClearAreaMic = () => {
        setSearchAreaMic("");                         
        localStorage.removeItem("globalFilter");    
        setSitesAreas(areaMicData);                    
    };

    const handleExportMicArea = async () => {
        setLoadingExport(true);

        try {
            const XLSX = await import("xlsx");

          const _report = sitesAreas.map((item, index) => ({
                "#": index + 1,
                Área: item.name ?? "---",
                Sitio: item.nombre_sitio ?? "---"
                    
            }));

            const worksheet = XLSX.utils.json_to_sheet(_report);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Listado de áreas");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const dataBlob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "catálogo_área.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al generar el Excel", error);
        }

        setLoadingExport(false);
    };

    return {
        sitesAreas, method, validaciones,
        name, id_mic_site, sites,
        handleInputChange, loading, handleSearchSiteArea,
        toggle, modal, modalTitle,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        nextPage, previousPage, goToPage, totalPageCount, currentPage,

        closeDeleteAlert, openDeleteAlert, showDeleteAlert, modalAlert,
        closeDialog,

        handleExportMicArea, handleClearAreaMic, handleSearch, loadingExport,
        searchAreaMic
    }
}
